import { connect } from 'react-redux'
import { login, getUser, submitMFA } from '../../../store/user'
import LoginView from '../components/LoginView'

const mapDispatchToProps = {
  login,
  submitMFA,
  getUser
}

export default connect(null, mapDispatchToProps)(LoginView)



// WEBPACK FOOTER //
// ./src/routes/Login/containers/LoginContainer.jsx